<template>
  <svg
    class="custom-icon"
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.91304 9.06676V10.5743C3.91353 10.8006 3.99966 11.0181 4.15348 11.1811C4.30731 11.3439 4.51681 11.4396 4.7382 11.4482C4.95948 11.4568 5.17553 11.3774 5.34088 11.2267L7.98255 8.81252C8.20819 8.6058 8.33715 8.31065 8.33715 8.00091C8.33715 7.69113 8.2082 7.39611 7.98255 7.18941L5.34088 4.77338C5.17553 4.62271 4.95948 4.54335 4.7382 4.5519C4.51681 4.56046 4.3073 4.65619 4.15348 4.81902C3.99966 4.98196 3.91353 5.19946 3.91304 5.42578V6.93333H0V2.13333C0 1.56762 0.219816 1.02495 0.611304 0.624889C1.00267 0.22473 1.53338 0 2.08696 0H9.91304C10.4666 0 10.9973 0.224702 11.3887 0.624889C11.7802 1.02495 12 1.56759 12 2.13333V13.8667C12 14.4324 11.7802 14.975 11.3887 15.3751C10.9973 15.7753 10.4666 16 9.91304 16H2.08696C1.53342 16 1.00267 15.7753 0.611304 15.3751C0.219844 14.975 0 14.4324 0 13.8667V9.06667L3.91304 9.06676Z"
    />
  </svg>
</template>
